import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=02a66507&scoped=true"
import script from "./CustomerDetails.vue?vue&type=script&lang=js"
export * from "./CustomerDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetails.vue?vue&type=style&index=0&id=02a66507&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a66507",
  null
  
)

export default component.exports